import React, { useRef, useEffect } from 'react';
import CheckmarkIcon from '@common/components/icons/CheckmarkIcon';
import MinusIcon from '@common/components/icons/MinusIcon';
import * as styles from './index.module.css';

export const CheckboxCell = React.memo(
  ({ row, rowId, selectedRowIds, handleSelectRow, disabled = false }) => {
    const id = rowId !== undefined ? rowId : row.original.id;
    return (
      <span className={`${styles['checkbox-container']} ${disabled ? styles['checkbox-disabled'] : ''}`}>
        <input
          type="checkbox"
          checked={!!selectedRowIds[id]}
          onChange={(e) => handleSelectRow(id, e.target.checked)}
          className={styles['custom-checkbox']}
          disabled={disabled}
        />
        {!!selectedRowIds[id] && (
          <span className={styles['checkbox-icon-container']}>
            <CheckmarkIcon />
          </span>
        )}
      </span>
    );
  },
);

export const CheckboxHeader = React.memo(
  ({ allRowsSelected, someRowsSelected, handleSelectAll }) => {
    const checkboxRef = useRef(null);

    useEffect(() => {
      if (checkboxRef.current) {
        checkboxRef.current.indeterminate =
          !allRowsSelected && someRowsSelected;
      }
    }, [allRowsSelected, someRowsSelected]);

    return (
      <span className={styles['checkbox-container']}>
        <input
          type="checkbox"
          checked={allRowsSelected}
          ref={checkboxRef}
          onChange={handleSelectAll}
          className={styles['custom-checkbox']}
        />
        {/* Custom icon for checked/indeterminate */}
        {(allRowsSelected || (someRowsSelected && !allRowsSelected)) && (
          <span className={styles['checkbox-icon-container']}>
            {allRowsSelected ? <CheckmarkIcon /> : <MinusIcon />}
          </span>
        )}
      </span>
    );
  },
);

